/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { ContentAiUpdateUserArticleContentMutationRequest, ContentAiUpdateUserArticleContentMutationResponse, ContentAiUpdateUserArticleContentPathParams, ContentAiUpdateUserArticleContent401, ContentAiUpdateUserArticleContent403 } from "../models/ContentAiUpdateUserArticleContent";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { contentAiUpdateUserArticleContent } from "../axios/contentAiUpdateUserArticleContent";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const contentAiUpdateUserArticleContentMutationKey = () => [{ url: '/content-ai/v1/contents/:id/user-article' }] as const

export type ContentAiUpdateUserArticleContentMutationKey = ReturnType<typeof contentAiUpdateUserArticleContentMutationKey>

export function contentAiUpdateUserArticleContentMutationOptions<TContext = unknown>(config: Partial<RequestConfig<ContentAiUpdateUserArticleContentMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = contentAiUpdateUserArticleContentMutationKey()
        return mutationOptions<ContentAiUpdateUserArticleContentMutationResponse, ResponseErrorConfig<ContentAiUpdateUserArticleContent401 | ContentAiUpdateUserArticleContent403>, {id: ContentAiUpdateUserArticleContentPathParams["id"], data: ContentAiUpdateUserArticleContentMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ id, data }) => {
            return contentAiUpdateUserArticleContent(id, data, config)
          },
        })

}

/**
 * @summary Set article content after user edition
 * {@link /content-ai/v1/contents/:id/user-article}
 */
export function useContentAiUpdateUserArticleContent<TContext>(options: 
{
  mutation?: UseMutationOptions<ContentAiUpdateUserArticleContentMutationResponse, ResponseErrorConfig<ContentAiUpdateUserArticleContent401 | ContentAiUpdateUserArticleContent403>, {id: ContentAiUpdateUserArticleContentPathParams["id"], data: ContentAiUpdateUserArticleContentMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ContentAiUpdateUserArticleContentMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? contentAiUpdateUserArticleContentMutationKey()

          const baseOptions = contentAiUpdateUserArticleContentMutationOptions(config) as UseMutationOptions<ContentAiUpdateUserArticleContentMutationResponse, ResponseErrorConfig<ContentAiUpdateUserArticleContent401 | ContentAiUpdateUserArticleContent403>, {id: ContentAiUpdateUserArticleContentPathParams["id"], data: ContentAiUpdateUserArticleContentMutationRequest}, TContext>
          

          return useMutation<ContentAiUpdateUserArticleContentMutationResponse, ResponseErrorConfig<ContentAiUpdateUserArticleContent401 | ContentAiUpdateUserArticleContent403>, {id: ContentAiUpdateUserArticleContentPathParams["id"], data: ContentAiUpdateUserArticleContentMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ContentAiUpdateUserArticleContentMutationResponse, ResponseErrorConfig<ContentAiUpdateUserArticleContent401 | ContentAiUpdateUserArticleContent403>, {id: ContentAiUpdateUserArticleContentPathParams["id"], data: ContentAiUpdateUserArticleContentMutationRequest}, TContext>
      
}